import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year4/Summer/Time/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Time',
  field: 'Measurement',
  weeks: [5, 6],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Time/1YearsMonthsWeeksAndDays" */ './1YearsMonthsWeeksAndDays'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Time/2HoursMinutesAndSeconds" */ './2HoursMinutesAndSeconds'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Time/3ConvertBetweenAnalogueAndDigitalTimes" */ './3ConvertBetweenAnalogueAndDigitalTimes'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Time/4ConvertToThe24HourClock" */ './4ConvertToThe24HourClock'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Time/5ConvertFromThe24HourClock" */ './5ConvertFromThe24HourClock'
        )
    })
  ]
});
export default Block;
